import React from 'react';
import classes from './Input.module.css';

const Input = ({
  min,
  type,
  defaultValue,
  onChange,
  className,
  placeholder,
  onBlur,
  postfixClass,
  postfix = null,
  prefix = null,
  isInvalid,
  isRequired,
  maxLength,
  showFullBorder = false,
  autoFocus = false,
  containerClassName,
  ErrorMessage='',
  showTooltip=false,
  toolTipText=''
}) => {
  const checkExponentialForNumbers=(type,event)=>{
    if(type==='number'){
      return event.keyCode === 69 ? false : true
    }
    return true;
  }
  return (
    <div className={`${classes['form-input-container']} ${containerClassName}`}>
      {isRequired ? <span className={classes.asterisk}>*</span> : null}

      {prefix ? <span className={classes['prefix']}>{prefix}</span> : null}
      <input
        isRequired
        placeholder={placeholder}
        className={`${classes['form-input']} ${className} ${
          showFullBorder ? classes['full-border'] : ''
          } 
        ${
          isInvalid
            ? showFullBorder
              ? classes['full-border-invalid']
              : classes.invalid
            : ''
          }`}
        min={min}
        type={type}
        defaultValue={defaultValue}
        onChange={e => onChange(e.target.value)}
        onBlur={e => onBlur && onBlur(e.target.value)}
        maxLength={maxLength}
        autoFocus={autoFocus}
        onKeyDown={e=>checkExponentialForNumbers(type,e)}
        title=""
        data-toggle="tooltip"
      />
    {showTooltip?  <div className={classes['form-tooltip']}>{toolTipText}</div>:null}
      {postfix ? <span className={`${postfixClass}`}>{postfix}</span> : null}
      <br />
      <b style={{ color: 'red', fontSize: '12px' }}>{isInvalid ? ErrorMessage : ''}</b>
    </div>
  );
};

export default Input;
